import { Layout } from './layout';

Layout.displayName = 'Text';

export { Layout as Text };

export type { Props as TextProps } from './types';
